
export interface User {
    id: string;
    permissions: Array<Permission>;
    roles: Array<Role>;
}

export enum Permission {
    managerRead = 'MANAGER_READ',
    managerWrite = 'MANAGER_WRITE',
    memberRead = 'MEMBER_READ',
    memberWrite = 'MEMBER_WRITE',
    newsRead = 'NEWS_READ',
    newsWrite = 'NEWS_WRITE',
    requestRead = 'REQUEST_READ',
    requestWrite = 'REQUEST_WRITE',
    requestAcceptance = 'REQUEST_ACCEPTANCE',
    relativeRead = 'RELATIVE_READ',
    relativeWrite = 'RELATIVE_WRITE',
    relativeAcceptance = 'RELATIVE_ACCEPTANCE',
    auditRead = 'AUDIT_READ',
    proceduresRead = 'PROCEDURES_READ',
    proceduresWrite = 'PROCEDURES_WRITE',
    exportRead = 'EXPORT_READ',
    exportExecutor = 'EXPORT_EXECUTOR',
    importRead = 'IMPORT_READ',
    importWrite = 'IMPORT_WRITE',
    analyticsRead = 'ANALYTICS_READ'
}

export enum Role {
    backoffice = 'BACKOFFICE_ADMIN',
    customer = 'CUSTOMER'
}

export const TaxCodePattern = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/;
